<template>
  <div class="grid gap-24">
    <p class="text-[--raw-verydarkgrey]">
      {{ i18n(translations.intro) }}
    </p>

    <ul class="grid gap-8">
      <li v-for="asset in ASSETS" :key="asset.label.id">
        <a
          :href="i18n(asset.url)"
          target="_blank"
          rel="noopener"
          class="flex items-center gap-16 rounded-[1rem] bg-[white]/40 p-16 transition-colors duration-[var(--raw-fast)] ease-[var(--raw-ease-out-quart)] hover:bg-[white]/70 active:bg-[white]/70"
        >
          <span class="flex flex-1 flex-wrap items-baseline gap-x-8 gap-y-4">
            <span class="raw-heading-4">{{ i18n(asset.label) }}</span>
            <span
              v-if="asset.description"
              class="raw-body-3 text-[--raw-darkgrey]"
              >{{ i18n(asset.description) }}</span
            >
          </span>
          <RevIllustration
            src="/mine-my-phone/icons/right--flat.svg"
            alt=""
            aria-hidden="true"
            :width="20"
            :height="20"
            class="rounded-full shrink-0 bg-[white] p-4"
          />
        </a>
      </li>
    </ul>

    <section class="grid gap-8">
      <h3 class="raw-cta-2">{{ i18n(translations.contactTitle) }}</h3>
      <p class="text-[--raw-verydarkgrey]">
        <InlineMarkdown :message="translations.contactBody" />
      </p>
    </section>
  </div>
</template>

<script setup lang="ts">
import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'
import { RevIllustration } from '@ds/components/Illustration'

import InlineMarkdown from '~/scopes/campaign/components/UI/InlineMarkdown.vue'
import type { I18nDescriptor } from '~/scopes/campaign/data/metals/types'

import translations from './PressKitDoc.translations'

// Hrefs are still placeholders (see translations), and there is no `download` attribute
// because it is only honoured same-origin.
const i18n = useI18n()

interface PressAsset {
  label: I18nDescriptor
  description?: I18nDescriptor
  url: I18nDescriptor
}

// The client's order, which is theirs to set — nothing is sorted here.
const ASSETS: readonly PressAsset[] = [
  {
    label: translations.releaseLabel,
    url: translations.releaseUrl,
  },
  {
    label: translations.expertsLabel,
    description: translations.expertsDescription,
    url: translations.expertsUrl,
  },
  {
    label: translations.reportLabel,
    description: translations.reportDescription,
    url: translations.reportUrl,
  },
  {
    label: translations.faqLabel,
    url: translations.faqUrl,
  },
  {
    label: translations.visualsLabel,
    description: translations.visualsDescription,
    url: translations.visualsUrl,
  },
]
</script>
